// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2530":"c2218d1e6e03877b","4457":"eef8e2c6c455f8eb","4541":"2ddc695b35abfd28","4565":"641d7141a0d08db2"}[chunkId] + ".js";
};